<template>
  <div>
    <el-dialog title="对照原文" :append-to-body="true" :visible.sync="dialogVisible" width="90%">
      <div class="difference-panel">
        <div class="content-container">
          <div class="content-title">
            差异内容 （{{ differenceNumber === 0 ? '无差异' : differenceNumber + '个差异' }}）
          </div>
          <div ref="differenceDom" class="content-panel">
            <div v-html="differenceHtml"></div>
          </div>
        </div>
        <div class="content-container">
          <div class="content-title">
            <el-dropdown v-if="hasOld" @command="handleCommand">
              <span class="content-title">{{ selectMode }} <i class="el-icon-arrow-down el-icon--right"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="原文">原文</el-dropdown-item>
                <el-dropdown-item command="之前版本">之前版本</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span v-else>原文</span>
          </div>
          <div class="content-panel">
            <div v-html="compareHtml"></div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HtmlDiff from 'htmldiff-js'
export default {
  name: 'DisplayDifference',
  props: {
    visible: Boolean,
    originalHtml: String,
    editHtml: String,
    oldHtml: String,
    hasOld: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'visible',
    event: 'changeVisible'
  },
  data() {
    return {
      differenceNumber: 0,
      selectMode: '原文'
    }
  },
  methods: {
    handleGenHtml() {
      this.dialogVisible = false
    },
    handleCommand(command) {
      this.selectMode = command
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.$props.visible
      },
      set(val) {
        this.$emit('changeVisible', val)
      }
    },
    differenceHtml() {
      if (this.selectMode === '原文') {
        return HtmlDiff.execute(this.originalHtml, this.editHtml)
      } else {
        return HtmlDiff.execute(this.oldHtml, this.editHtml)
      }
    },
    compareHtml() {
      if (this.selectMode === '原文') {
        return this.originalHtml
      } else {
        return this.oldHtml
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          const delDiffCount = this.$refs.differenceDom.getElementsByTagName('del').length
          const insDiffCount = this.$refs.differenceDom.getElementsByTagName('ins').length
          this.differenceNumber = delDiffCount + insDiffCount
        })
      }
    },
    selectMode() {
      this.$nextTick(() => {
        const delDiffCount = this.$refs.differenceDom.getElementsByTagName('del').length
        const insDiffCount = this.$refs.differenceDom.getElementsByTagName('ins').length
        this.differenceNumber = delDiffCount + insDiffCount
      })
    }
  }
}
</script>

<style scoped lang="less">
.difference-panel {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.content-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.content-title {
  font-size: 16px;
  font-weight: 600;
  padding: 0 0 5px 0;
}
.content-panel {
  border: 1px solid #ccc;
  height: 100%;
  overflow: auto;
  padding: 10px;
}
.difference-panel {
  height: 85vh;
}
/deep/ .el-dialog {
  margin-top: 15px !important;
  margin: 0 auto 15px;
  .el-dialog__body {
    padding: 5px 20px 30px 20px;
  }
}
/deep/.w-e-tag {
  margin: 0px 3px;
  font-size: 14px;
  background-color: rgb(236, 245, 255);
  color: rgb(64, 158, 255);
  border: 1px solid rgb(217, 236, 255);
  border-radius: 3px;
  padding: 3px 8px;
}
/deep/del.diffdel {
  color: red;
  text-decoration: underline line-through;
}
/deep/del.diffmod {
  display: none;
  color: red;
  text-decoration: underline line-through;
}
/deep/ins.diffmod {
  color: #04c504;
  text-decoration: underline;
}
/deep/ins.diffins {
  color: #04c504;
  text-decoration: underline;
}
.difference-number {
  font-weight: 500;
  font-size: 14px;
  margin-left: 10px;
}
</style>
